import script from "./AvailabilityForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AvailabilityForm.vue?vue&type=script&setup=true&lang=js"

import "./AvailabilityForm.vue?vue&type=style&index=0&id=7ad35923&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ad35923"]])

export default __exports__